/* unplugin-vue-components disabled */import { render } from "./UserWeight.vue?vue&type=template&id=55fd31ac&scoped=true"
import script from "./UserWeight.vue?vue&type=script&lang=js"
export * from "./UserWeight.vue?vue&type=script&lang=js"

import "./UserWeight.vue?vue&type=style&index=0&id=55fd31ac&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fd31ac"]])

export default __exports__